import React, { useEffect, useState } from 'react';
import './index.less';
import { getRecommendBiddingList } from '../../../api';
import { completePictureLink } from '../utils';
import { Button, Divider, Spin, Typography, Tooltip } from 'antd';
import Empty from '@/components/core-empty';
import { delay } from 'lodash';
import { useDripSource } from '@/apis/dripDataSource';

const prefixCls = 'recommend-bid';
const biddingTypeMap = {
  1: 'SKU',
  2: 'SPU',
};

const RecommendBid = ({ getBidActivityAndAreaId = () => {}, mode, openSeckillLinkVersion }) => {
  const [recommendBiddingList, setRecommendBiddingList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [jumpInfo, setJumpInfo] = useState({});

  // drip数据源
  const [getDripSource] = useDripSource();
  const isGoNewRoomList = getDripSource('useNewOpenApplyVersionInErp', '0') == '1';

  useEffect(() => {
    setLoading(true);
    getRecommendBiddingList()
      .then((res) => {
        const { ret, msg, data } = res;
        if (ret !== '0') {
          throw msg || '百补活动接口请求失败';
        }
        const { activityId, areaId, channelId, resourceId, recommendBidList = [] } = data || {};
        getBidActivityAndAreaId(data);
        setJumpInfo({ activityId, areaId, channelId, resourceId });
        setRecommendBiddingList(recommendBidList || []);
      })
      .finally(() => setLoading(false));
  }, []);

  const jumpBid = (skuId) => {
    const { activityId, areaId, channelId, resourceId } = jumpInfo || {};
    log && log('yx_center', 'signupbidding', `{"sku":"${skuId}"}`);
    let newBidUrl;
    if (isGoNewRoomList) {
      newBidUrl = `/platform-marketing/resource-detail/apply-roomList/elpis/intranet/roomlist/enrolledManage/biddingEnroll?activityId=${activityId}&areaId=${areaId}&blockId=${areaId}&channelId=${channelId}&entry=1&from=acore&lineType=5&resourceId=${resourceId}`;
    } else {
      newBidUrl = `/platform-marketing/resource-detail/material-collection/openArea1/elpis/intranet/biddingEnroll?activityId=${activityId}&areaId=${areaId}&blockId=${areaId}&channelId=${channelId}&entry=1&from=acore&lineType=5&resourceId=${resourceId}`;
    }
    if (activityId && areaId) {
      window.open(newBidUrl);
    }
    return;
  };

  return (
    <div className={prefixCls}>
      {loading && (
        <div className={`${prefixCls}-loading`}>
          <Spin />
        </div>
      )}
      {!loading && !recommendBiddingList.length && (
        <div className={`${prefixCls}-empty`}>
          <Empty
            // image="https://img13.360buyimg.com/img/jfs/t1/184937/21/40274/4379/6551df79Fe49e1a5d/46817c2a76820f6a.png"
            description={
              <span style={{ color: 'rgba(0, 0, 0, 0.45)', marginTop: 20, fontSize: 12 }}>暂无可竞价商品</span>
            }
          />
        </div>
      )}
      {!!recommendBiddingList.length && (
        <div className={`${prefixCls}-list-container`}>
          {recommendBiddingList.map(({ skuId, biddingImg, biddingName, bidMaxPrice, biddingDesc, biddingType }) => (
            <div key={skuId} className={`${prefixCls}-item ${mode}`}>
              <img
                src={completePictureLink(biddingImg)}
                alt=""
                className={`${prefixCls}-item-img`}
                style={{ borderRadius: mode === 'special' && '8px' }}
              />
              <div className={`${prefixCls}-item-right`}>
                <Typography.Text ellipsis={{ tooltip: true }}>{biddingName}</Typography.Text>
                <div className={`${prefixCls}-item-right-des`}>
                  <span>{biddingTypeMap[biddingType]}</span>
                  <Divider type="vertical" />
                  <span className="text-ellipsis">{biddingDesc}</span>
                </div>
                <div className={`${prefixCls}-item-right-opt`}>
                  <Tooltip title="竞拍参考价仅作参考，请以“填写报名信息“页展示的建议价为准">
                    <span>竞拍参考价：¥ {bidMaxPrice}</span>
                  </Tooltip>
                  <Button
                    ghost
                    type="primary"
                    shape="round"
                    size={'small'}
                    style={{ fontSize: 12 }}
                    onClick={() => delay(() => jumpBid(skuId), 200)}
                    className={mode === 'special' && 'btn'}
                  >
                    参与竞价
                  </Button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default RecommendBid;
